import { dictionaryService } from "../../../dataFlow";
import { useDictionaryItem, useParameter } from "../../../shared";
import { BUSINESS_UNIT, SLIDE_NUMBER } from "../constants";

export function useSlideSubtitle(): string {
  const [commodities] = useParameter<number>("@commodities");

  const [refYear] = useParameter<number>("@ref_year");
  
  const [, commodityNameObj] = useDictionaryItem(dictionaryService, "slides-commodities", commodities, {
    business_unit: BUSINESS_UNIT,
    slide: SLIDE_NUMBER,
  });
  const [, refYearNameObj] = useDictionaryItem(dictionaryService, "slides-reference-year-slide-34", refYear);

  const commodityName = commodityNameObj ? Object.values(commodityNameObj)[0] : "";
  const refYearName = refYearNameObj && refYearNameObj[9] ? refYearNameObj[9] : "";
  return `${commodityName}, ${refYearName}`;
}
